import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaHeadset,
  FaTicketAlt,
  FaClock,
  FaCreditCard,
  FaTimes,
} from "react-icons/fa";

const CallHelpCard = () => {
  const [showCard, setShowCard] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setShowCard(true), 1200);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <AnimatePresence>
      {showCard && (
        <motion.div
          className="fixed top-0 left-0 w-full h-full bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 px-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="
              bg-white/90 backdrop-blur-xl 
              rounded-3xl shadow-2xl 
              p-7 max-w-md w-full text-center 
              relative border border-gray-200
            "
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.35 }}
          >
            {/* Close button */}
            <button
              onClick={() => setShowCard(false)}
              className="absolute top-4 right-4 text-gray-600 hover:text-red-500"
            >
              <FaTimes size={22} />
            </button>

            {/* Heading */}
            <h2 className="text-2xl font-extrabold mb-2 text-blue-800 tracking-wide">
              Need Help Booking?
            </h2>
            <p className="text-sm text-gray-600 mb-5">
              Speak to a live travel expert — we’re available 24/7.
            </p>

            {/* Main CTA */}
            <a
              href="tel:+18887112909"
              className="
                flex items-center justify-center gap-2 
                bg-gradient-to-r from-teal-500 to-teal-600 
                hover:from-teal-600 hover:to-teal-700 
                text-white font-bold 
                px-5 py-3 rounded-full shadow-lg 
                mb-6 text-lg transition-all
              "
            >
              <img
                src="/assets/US.png"
                alt="US Flag"
                className="w-6 h-4 object-cover"
              />
              +1 888-711-2909
            </a>

            {/* “Why Call?” */}
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              Why call our travel experts?
            </h3>

            <div className="grid grid-cols-2 gap-x-4 gap-y-4 text-sm text-gray-700">
              <div className="flex items-center gap-2">
                <FaHeadset className="text-teal-600" />
                Expert support
              </div>
              <div className="flex items-center gap-2">
                <FaClock className="text-teal-600" />
                24/7 help
              </div>
              <div className="flex items-center gap-2">
                <FaTicketAlt className="text-teal-600" />
                Quick booking
              </div>
              <div className="flex items-center gap-2">
                <FaCreditCard className="text-teal-600" />
                Easy payments
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CallHelpCard;
